export default __webpack_public_path__ + "media/images/tenant/timeline/number_1-4c439a848da8b7d9497c2f195ab66e37.svg";